import { placementChecker, getRect } from '../utils';
export const PoppingFlip = (instance) => {
	const { target, scrollView } = instance 
	const {
		placement,
		offset: [offsetX = 10, offsetY = 10],
	} = instance.options;
	const { 
		scrollTop, 
		scrollLeft, 
		clientWidth: viewWidth, 
		clientHeight: viewHeight 
	} = scrollView;
	const { 
		top = target.offsetTop - scrollTop, 
		left = target.offsetLeft - scrollLeft, 
		height = target.offsetHeight, 
		width = target.offsetWidth 
	} = scrollView === document.documentElement 
		? getRect(target) 
		: {};
	const bordertop = 0;
	const borderleft = 0;
	const borderbottom = viewHeight;
	const borderright = viewWidth; 
	const popover = getRect(instance.dialog);
	const betterTop = borderbottom - (top + height / 2) < borderbottom / 2;
	const betterLeft = borderright - (left + width / 2) < borderright / 2;
	const targetTopDepth = top + height;
	const targetLeftDepth = left + width;
	const isTargetExceedTop = bordertop > top;
	const isTargetExceedBottom = borderbottom < targetTopDepth;
	const isTargetExceedLeft = borderleft > left;
	const isTargetExceedRight = borderright < targetLeftDepth;
	const isExceedTop = bordertop > top - (popover.height + offsetY);
	const isExceedBottom =
		borderbottom < targetTopDepth + popover.height + offsetY;
	const isExceedLeft = borderleft > left - (popover.width + offsetX);
	const isExceedRight = borderright < targetLeftDepth + popover.width + offsetX;
	const Yside = (width - popover.width) / 2;
	const isExceedYsideLeft = borderleft > left + Yside && width < popover.width;
	const isExceedYsideRight =
		borderright < targetLeftDepth - Yside && width < popover.width;
	const Xside = (height - popover.height) / 2;
	const isExceedXsideTop = bordertop > top + Xside && height < popover.height;
	const isExceedXsideBottom =
		borderbottom < targetTopDepth - Xside && height < popover.height;
	const suffixX = width - popover.width;
	const isExceedSuffixRight = borderright < targetLeftDepth - suffixX;
	const isExceedSuffixLeft = borderleft > left + suffixX;
	const suffixY = height - popover.height;
	const isExceedSuffixBottom = borderbottom < targetTopDepth - suffixY;
	const isExceedSuffixTop = bordertop > top + suffixY;
	const {
		suffixLeft,
		suffixRight,
		suffixTop,
		suffixBottom,
		isTop,
		isBottom,
		isLeft,
		isRight,
	} = placementChecker(placement);

	const replace = (place, ol, ne) => place.replace(ol, ne);

	const str_top = 'top',
		str_left = 'left',
		str_right = 'right',
		str_bottom = 'bottom',
		dash_top = '-top',
		dash_left = '-left',
		dash_right = '-right',
		dash_bottom = '-bottom';

	let new_placement;

	if ([str_top, str_bottom].includes(placement)) {
		let gather = placement;
		if (isTop && (isTargetExceedTop || isExceedTop)) {
			gather = replace(gather, str_top, str_bottom);
		}
		if (isBottom && (isTargetExceedBottom || isExceedBottom)) {
			gather = replace(gather, str_bottom, str_top);
		}
		if (isExceedYsideLeft) {
			gather += dash_right;
		}
		if (isExceedYsideRight) {
			gather += dash_left;
		}

		if (
			isTargetExceedLeft ||
			isTargetExceedRight ||
			(isExceedTop && isExceedBottom)
		) {
			if (isTargetExceedLeft) {
				gather = str_right;
			}
			if (isTargetExceedRight) {
				gather = str_left;
			}

			if (isExceedTop && isExceedBottom) {
				gather =
					isExceedRight && betterLeft
						? str_left
						: isExceedLeft && !betterLeft
						? str_right
						: betterLeft
						? str_left
						: str_right;
			}

			if (isExceedXsideTop) {
				gather += dash_bottom;
			}
			if (isExceedXsideBottom) {
				gather += dash_top;
			}
		}

		if (
			isExceedRight &&
			isExceedLeft &&
			!(
				(isExceedYsideLeft && !isExceedSuffixRight) ||
				(isExceedYsideRight && !isExceedSuffixLeft)
			)
		) {
			gather =
				isExceedBottom && betterTop
					? str_top
					: isExceedTop
					? str_bottom
					: placement;
		}

		if (gather !== placement) {
			new_placement = gather;
		}
	}

	if ([str_left, str_right].includes(placement)) {
		let gather = placement;
		if (isLeft && (isTargetExceedLeft || isExceedLeft)) {
			gather = replace(gather, str_left, str_right);
		}
		if (isRight && (isTargetExceedRight || isExceedRight)) {
			gather = replace(gather, str_right, str_left);
		}
		if (isExceedXsideTop) {
			gather += dash_bottom;
		}
		if (isExceedXsideBottom) {
			gather += dash_top;
		}

		if (
			isTargetExceedTop ||
			isTargetExceedBottom ||
			(isExceedRight && isExceedLeft)
		) {
			if (isTargetExceedTop) {
				gather = str_bottom;
			}
			if (isTargetExceedBottom) {
				gather = str_top;
			}

			if (isExceedRight && isExceedLeft) {
				gather =
					isExceedBottom && betterTop
						? str_top
						: isExceedTop && !betterTop
						? str_bottom
						: betterTop
						? str_top
						: str_bottom;
			}

			if (isExceedYsideLeft) {
				gather += dash_right;
			}
			if (isExceedYsideRight) {
				gather += dash_left;
			}
		}

		if (
			isExceedTop &&
			isExceedBottom &&
			!(
				(isExceedXsideTop && !isExceedSuffixBottom) ||
				(isExceedXsideBottom && !isExceedSuffixTop)
			)
		) {
			gather =
				isExceedRight && betterLeft
					? str_left
					: isExceedLeft
					? str_right
					: placement;
		}

		if (gather !== placement) {
			new_placement = gather;
		}
	}

	if (suffixTop || suffixBottom) {
		let gather = placement;
		if (isLeft && (isTargetExceedLeft || isExceedLeft)) {
			gather = replace(gather, str_left, str_right);
		}
		if (isRight && (isTargetExceedRight || isExceedRight)) {
			gather = replace(gather, str_right, str_left);
		}
		if (suffixTop && isExceedSuffixTop) {
			gather = replace(gather, str_top, str_bottom);
		}

		if (suffixBottom && isExceedSuffixBottom) {
			gather = replace(gather, str_bottom, str_top);
		}

		if (isExceedSuffixTop && isExceedSuffixBottom) {
			gather =
				isExceedRight && betterLeft
					? str_left
					: isExceedLeft && !betterLeft
					? str_right
					: isLeft
					? str_left
					: str_right;
		}
		if (
			isTargetExceedTop ||
			isTargetExceedBottom ||
			(isExceedRight && isExceedLeft)
		) {
			if (isTargetExceedTop) {
				gather = str_bottom;
			}
			if (isTargetExceedBottom) {
				gather = str_top;
			}

			if (isExceedRight && isExceedLeft) {
				gather =
					isExceedBottom && betterTop
						? str_top
						: isExceedTop && !betterTop
						? str_bottom
						: suffixTop
						? str_top
						: str_bottom;
			}

			if (isExceedYsideLeft) {
				gather += dash_right;
			}
			if (isExceedYsideRight) {
				gather += dash_left;
			}
		}

		if (gather !== placement) {
			new_placement = gather;
		}
	}

	if (suffixLeft || suffixRight) {
		let gather = placement;
		if (isTop && (isTargetExceedTop || isExceedTop)) {
			gather = replace(gather, str_top, str_bottom);
		}
		if (isBottom && (isTargetExceedBottom || isExceedBottom)) {
			gather = replace(gather, str_bottom, str_top);
		}
		if (suffixLeft && isExceedSuffixLeft) {
			gather = replace(gather, str_left, str_right);
		}

		if (suffixRight && isExceedSuffixRight) {
			gather = replace(gather, str_right, str_left);
		}

		if (
			isTargetExceedLeft ||
			isTargetExceedRight ||
			(isExceedTop && isExceedBottom)
		) {
			if (isTargetExceedLeft) {
				gather = str_right;
			}
			if (isTargetExceedRight) {
				gather = str_left;
			}

			if (isExceedTop && isExceedBottom) {
				gather =
					isExceedRight && betterLeft
						? str_left
						: isExceedLeft && !betterLeft
						? str_right
						: suffixLeft
						? str_left
						: str_right;
			}

			if (isExceedXsideTop) {
				gather += dash_bottom;
			}
			if (isExceedXsideBottom) {
				gather += dash_top;
			}
		}

		if (isExceedSuffixRight && isExceedSuffixLeft) {
			gather =
				isExceedBottom && betterTop
					? str_top
					: isExceedTop && !betterTop
					? str_bottom
					: isTop
					? str_top
					: str_bottom;
		}

		if (gather !== placement) {
			new_placement = gather;
		}
	}

	if (instance.options.allowFlipManifestation) {
		instance.options.placement = new_placement || placement;
	} else {
		return { placement: new_placement || placement };
	}
};
